<script setup lang="ts">
const { theme } = useTheme()
const route = useRoute()
const appReady = useAppReady()
const showSplashScreen = ref(route.name === 'index')

watch(theme, (v) => {
  if (import.meta.client) {
    document.body.classList.remove('dark', 'light')
    document.body.classList.add(v)
  }
}, {
  immediate: true,
})

function onHideScreenSplash() {
  showSplashScreen.value = false
  appReady.value = true
}

onMounted(() => {
  if (route.name !== 'index') {
    appReady.value = true
  }
})

</script>

<template>
  <AppConfig v-slot="{ xs, lg }">
    <div id="app" :class="{ xs, lg, [theme]: true, [route.name!.toString()]: true }">
      <MouseEffect />
      <CircleMoveEffect />
      <AppHeader />
      <main class="app-body">
        <NuxtPage />
        <AppFooter />
      </main>
      <AppMenu />
      <AppLoading />
      <SplashScreen v-if="showSplashScreen" @out="onHideScreenSplash"  />
    </div>
  </AppConfig>
</template>

<style lang="scss">
#app {
  &.lg {
    // min-width: 1200PX;
    max-width: 1920PX;
    margin: 0 auto;
    // .app-body {
    //   min-width: 1200PX;
    // }
  }
}
</style>
